(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomWorkFlowTypeAttributeDialogController', CustomWorkFlowTypeAttributeDialogController);

    CustomWorkFlowTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state','$stateParams', 'entity', 'CustomWorkFlowTypeAttribute'];

    function CustomWorkFlowTypeAttributeDialogController ($timeout, $scope, $state ,$stateParams, entity, CustomWorkFlowTypeAttribute) {
        var vm = this;

        vm.customWorkFlowTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
       // vm.customworkflowtypeattributevalues = CustomWorkFlowTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customWorkFlowTypeAttribute.customWorkFlowTypeAttributeValues != null && vm.customWorkFlowTypeAttribute.customWorkFlowTypeAttributeValues.length != 0) {
			vm.items = vm.customWorkFlowTypeAttribute.customWorkFlowTypeAttributeValues;
		}
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if  ( vm.customWorkFlowTypeAttribute.id !== null) {
            	
            	 vm.customWorkFlowTypeAttribute.customWorkFlowTypeAttributeValues = [];
				for (var i = 0; i < vm.items.length; i++) {
					 vm.customWorkFlowTypeAttribute.customWorkFlowTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
                CustomWorkFlowTypeAttribute.update(vm.customWorkFlowTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customWorkFlowTypeAttribute.customWorkFlowTypeAttributeValues = [];

				for (var i = 0; i < vm.items.length; i++) {
					 vm.customWorkFlowTypeAttribute.customWorkFlowTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
				
                CustomWorkFlowTypeAttribute.save(vm.customWorkFlowTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customWorkFlowTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-work-flow-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
